<template>
  <v-app>
    <Topbar v-if="userLogged" v-bind:userName="'user'" v-bind:companyName="'WinGD'"/>
    <v-content fluid style="background-color:rgb(244,244,244);height:100vh;">
      <Titlebar v-if="userLogged"/>
      <div style="margin-top: 40px">
        <router-view/>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import Topbar from './components/Topbar'
import Titlebar from './components/Titlebar'
//import Titlebar from '../../EDSOnLine/src/controls/Titlebar'

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';

import {store} from "./main.js"

export default {
  name: 'App',
  components: {
    Topbar,
    Titlebar
  },
  data() {
    return {}
  },
  created() {
    if (window.$cookies.isKey('user')) {
      store.userProfile = window.$cookies.get('user');
      store.userLogged = true;
    }
  },
  computed: {
    userName: function () {
      return store.userProfile.displayName;
    },
    userLogged: function () {
      return store.userLogged;
    }
  }
}
</script>

<style scoped>
</style>

